'use strict';

const P = require('./protocol.js'); // Persist intent BEFORE a quote POST. A lost response/reload must resume the same
// intent, never unlock a limited step or create a replacement payable quote.


function createQuoteIntents({
  storage,
  scopeKey
}) {
  P.check(storage && P.id(scopeKey), 'QUOTE_INTENT_STORAGE_REQUIRED');
  const key = 'op-card-quote-intents-v1:' + scopeKey;
  let cached = null;

  function read() {
    var _data;

    if (cached) return cached;
    const raw = storage.getItem(key);
    if (!raw) return cached = new Map();
    let data;

    try {
      data = JSON.parse(raw);
    } catch {
      throw Error('INVALID_SAVED_QUOTE_INTENTS');
    }

    P.check(((_data = data) === null || _data === void 0 ? void 0 : _data.schema) === 1 && Array.isArray(data.entries) && data.entries.length <= 256, 'INVALID_SAVED_QUOTE_INTENTS');
    const map = new Map();

    for (const [name, value] of data.entries) {
      P.check(typeof name === 'string' && name.length <= 361 && value && P.id(value.requestId) && (value.quoteId === null || P.id(value.quoteId)) && !map.has(name), 'INVALID_SAVED_QUOTE_INTENTS');
      map.set(name, value);
    }

    return cached = map;
  }

  function save(next) {
    P.check(next.size <= 256, 'QUOTE_INTENT_STORAGE_LIMIT');
    const raw = JSON.stringify({
      schema: 1,
      entries: [...next]
    });
    storage.setItem(key, raw);
    P.check(storage.getItem(key) === raw, 'QUOTE_INTENT_NOT_PERSISTED');
    cached = next;
  }

  return Object.freeze({
    has: name => read().has(name),
    get: name => read().get(name),

    set(name, value) {
      const next = new Map(read());
      next.set(name, { ...value
      });
      save(next);
    },

    delete(name) {
      const next = new Map(read());
      next.delete(name);
      save(next);
    },

    [Symbol.iterator]() {
      return read()[Symbol.iterator]();
    }

  });
}

module.exports = {
  createQuoteIntents
};
